// src/components/homepage_content/LiveMatches.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBetSlip } from '../../context/BetSlipContext';
import MatchCard from './MatchCard';

const LiveMatches = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { betslipCount } = useBetSlip();

  // Demo live matches data
  const demoMatches = [
    {
      id: 'live-1',
      homeTeam: 'Manchester United',
      awayTeam: 'Manchester City',
      league: 'Premier League',
      sport: 'football',
      time: new Date(Date.now() + 3600000).toISOString(), // 1 hour from now
      score: '1-0',
      minute: '35',
      odds: {
        home: 2.85,
        draw: 3.40,
        away: 2.45
      },
      additionalMarkets: [
        { name: 'GG', odds: 1.45 },
        { name: 'Over 2.5', odds: 1.85 }
      ]
    },
    {
      id: 'live-2',
      homeTeam: 'Real Madrid',
      awayTeam: 'Barcelona',
      league: 'La Liga',
      sport: 'football',
      time: new Date(Date.now() + 7200000).toISOString(), // 2 hours from now
      score: '0-0',
      minute: '15',
      odds: {
        home: 2.10,
        draw: 3.50,
        away: 3.40
      },
      additionalMarkets: [
        { name: 'BTTS', odds: 1.60 },
        { name: 'Over 2.5', odds: 1.90 }
      ]
    },
    {
      id: 'live-3',
      homeTeam: 'Bayern Munich',
      awayTeam: 'Borussia Dortmund',
      league: 'Bundesliga',
      sport: 'football',
      time: new Date(Date.now() + 10800000).toISOString(), // 3 hours from now
      odds: {
        home: 1.75,
        draw: 3.80,
        away: 4.50
      }
    }
  ];

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setMatches(demoMatches);
      setLoading(false);
    }, 800);
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-900 rounded-xl p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-gray-800 rounded w-1/4"></div>
          <div className="h-32 bg-gray-800 rounded"></div>
          <div className="h-32 bg-gray-800 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-900 rounded-xl p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
          <h2 className="text-xl font-bold text-white">Live Matches</h2>
        </div>
        
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate('/live')}
            className="text-blue-400 hover:text-blue-300 text-sm font-medium"
          >
            View All →
          </button>
          
          <button
            onClick={() => navigate('/betslip')}
            className="relative px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors"
          >
            Betslip
            {betslipCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                {betslipCount}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Matches Grid */}
      {matches.length === 0 ? (
        <div className="text-center py-8">
          <div className="text-4xl mb-4">📺</div>
          <p className="text-gray-400">No live matches at the moment</p>
          <button
            onClick={() => navigate('/sports')}
            className="mt-4 text-blue-400 hover:text-blue-300"
          >
            Browse upcoming matches →
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {matches.map(match => (
            <MatchCard key={match.id} match={match} />
          ))}
        </div>
      )}

      {/* Quick Bet Info */}
      <div className="mt-6 pt-6 border-t border-gray-800">
        <div className="flex items-center justify-between text-sm text-gray-400">
          <div className="flex items-center space-x-2">
            <span className="w-2 h-2 bg-green-500 rounded-full"></span>
            <span>Click odds to add to betslip</span>
          </div>
          <div className="flex items-center space-x-4">
            <span>1 = Home</span>
            <span>X = Draw</span>
            <span>2 = Away</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveMatches;